import { Component, OnDestroy, OnInit } from '@angular/core';
import { MemberService } from '../../service/member.service';
import { OrderByPipe } from '../../pipe/order-by.pipe';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { addEquipment, IAdditionalEquipmentTypeModel, IEditLocationModel, JobType, ServiceType } from 'src/app/service/service-request';
import { VendorService } from 'src/app/service/vendor.service';
import { StateViewModel, ICityViewModel } from 'src/app/service/state.model';
import { ToastrService } from 'ngx-toastr';
import { AddressType, DefaultGUID, RoleName, ServiceTypeNames } from 'src/app/@shared/constants/Constant';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { CityViewModel, IAirportCodeList, IGetLocationViewModel } from 'src/app/service/vehicle.model';
import { LocationService } from 'src/app/service/location.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { ConfirmationMsg } from 'src/app/@shared/constants/confirmation-msg.constant';

declare var $;

@Component({
  selector: 'app-manage-data',
  templateUrl: './manage-data.component.html',
  styleUrls: ['./manage-data.component.css'],
  providers: [OrderByPipe],
})
export class ManageDataComponent implements OnInit, OnDestroy {
  constructor(
    private _memberService: MemberService,
    private _serviceRequestService: ServiceRequestService,
    private _vendorService: VendorService,
    private _toast: ToastrService,
    private _locationService: LocationService,
  ) {}

  private _subscriptions: Subscription = new Subscription();
  public serviceRequestTypes = [];
  public organId;
  public equipmentId;
  public specimenId;
  public isShowAddEquipment: boolean;
  public isEditLocation: boolean = false; // reference in template file
  public isShowAddOrgan: boolean;
  public isShowAddAdditionalEquipmentType: boolean = false; // reference in template file
  public isShowAddSpecimen: boolean;
  public user: ILoggedInUserViewModel;
  public AddressType: string[] = AddressType; // reference in template file
  public isShowAddAirportCode: boolean = false; // reference in template file
  public airport: string;
  public roleName = RoleName; // reference in template file
  public serviceType = ServiceTypeNames; // reference in template file
  public mapOriginDataModel = {
    serviceLocations: [] as IGetLocationViewModel[],
    mapOriginConfig: {
      displayKey: 'addressName',
      search: true,
      placeholder: 'Select Location',
      height: '400px',
    },
    locationSelected: null as IGetLocationViewModel,
  }; // reference in template file
  public equipmentDataModel = {
    equipmentTypes: [] as JobType[],
    EquipmentSetting: {
      displayKey: 'jobTypeName',
      search: true,
      placeholder: 'Select Equipment',
      height: '400px',
    },
    selectedEquipment: null as JobType,
  }; // reference in template file
  public organDataModel = {
    organTypes: [] as JobType[],
    OrganSetting: {
      displayKey: 'jobTypeName',
      search: true,
      placeholder: 'Select Organ',
      height: '400px',
    },
    selectedOrgan: null as JobType,
  }; // reference in template file
  public additionalEquipmentDataModel = {
    additionalEquipmentTypeList: [] as IAdditionalEquipmentTypeModel[],
    additionalEquipmentDropdownSetting: {
      displayKey: 'additionalEquipmentName',
      search: true,
      placeholder: 'Select Additional Equipment Type',
      height: '400px',
    },
    selectedAdditionalEquipmentType: null as IAdditionalEquipmentTypeModel,
  }; // reference in template file
  public specimenDataModel = {
    specimenTypes: [] as JobType[],
    SpecimenSetting: {
      displayKey: 'jobTypeName',
      search: true,
      placeholder: 'Select Specimen',
      height: '400px',
    },
    selectedSpecimen: null as JobType,
  }; // reference in template file
  public stateDataModel = {
    stateList: [] as StateViewModel[],
    StateSetting: {
      displayKey: 'stateName',
      search: true,
      placeholder: 'Select State',
      height: '280px',
    },
  }; // reference in template file
  public cityDataModel = {
    cityList: [] as CityViewModel[],
    CitySetting: {
      displayKey: 'cityName',
      search: true,
      placeholder: 'Select City',
      height: '280px',
    },
    selectedCity: null as CityViewModel,
  }; // reference in template file
  public locationDisplayName: string = null;
  public isInternalReadOnly: boolean = false;
  public airportCodeList: IAirportCodeList[] = [];

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === RoleName.InternalReadOnly;
    this.getAllServiceLocations();
    this.getStateList();
    this.getAllAirportCodeList();
    if (this.user.role != RoleName.Accounting) {
      this.getAdditionalEquipmentTypes();
    }
    this.isShowAddEquipment = false;
    this.isShowAddOrgan = false;
    this.isShowAddSpecimen = false;
    if (this.isInternalReadOnly) {
      this._serviceRequestService.isTimeZoneLockSubject$.next(true);
    } else if (this.user.role == RoleName.Management) {
      this._serviceRequestService.isTimeZoneLockSubject$.next(false);
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  public getAdditionalEquipmentTypes() {
    this._subscriptions.add(
      this._serviceRequestService.getAdditionalEquipmentTypes().subscribe(
        (response: IAdditionalEquipmentTypeModel[]) => {
          this.additionalEquipmentDataModel.additionalEquipmentTypeList = response;
        },
        (error) => {
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      ),
    );
  }

  getJobTypeData() {
    this._subscriptions.add(
      this._serviceRequestService.getServiceTypes().subscribe(
        (response) => {
          this.serviceRequestTypes = response;
          this.equipmentId = this.serviceRequestTypes.find((x) => x.serviceTypeName == ServiceTypeNames.equipment);
          this.getJobTypesByServiceType(this.equipmentId.serviceTypeId);
          this.organId = this.serviceRequestTypes.find((x) => x.serviceTypeName == ServiceTypeNames.organ);
          this.getJobTypesByServiceType(this.organId.serviceTypeId);
          this.specimenId = this.serviceRequestTypes.find((x) => x.serviceTypeName == ServiceTypeNames.specimen);
          this.getJobTypesByServiceType(this.specimenId.serviceTypeId);
        },
        (error) => {
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      ),
    );
  }

  getAllServiceLocations(flag?) {
    this.loader = true;
    this._subscriptions.add(
      this._locationService.getAllServiceLocations().subscribe(
        (response: IGetLocationViewModel[]) => {
          this.mapOriginDataModel.serviceLocations = response;
          flag == undefined ? this.getJobTypeData() : null;
          this.loader = false;
        },
        (error) => {
          this.loader = false;
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      ),
    );
  }

  clickDropDown(id) {
    $('#' + id + ' .search-container :input').focus();
  } // reference in template file

  getJobTypesByServiceType(jobType) {
    this._subscriptions.add(
      this._serviceRequestService.getAllJobById(jobType).subscribe(
        (response) => {
          switch (jobType) {
            case this.organId.serviceTypeId:
              this.organDataModel.organTypes = response;
              break;
            case this.equipmentId.serviceTypeId:
              this.equipmentDataModel.equipmentTypes = response;
              break;
            case this.specimenId.serviceTypeId:
              this.specimenDataModel.specimenTypes = response;
              // this.loader = false;
              break;
            default:
              break;
          }
        },
        (error) => {
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      ),
    );
  }

  public addEquip: addEquipment = {
    serviceType: '',
    equipmentType: '',
    appLevel: '',
  };
  public loader = false;

  addJobType(type) {
    if (this.addEquip.equipmentType != '') {
      this.loader = true;
      this.addEquip.serviceType = type;
      switch (type) {
        case ServiceTypeNames.equipment:
          this.addEquip.appLevel = 'EquipmentType';
          break;
        case ServiceTypeNames.organ:
          this.addEquip.appLevel = 'OrganType';
          break;
        case ServiceTypeNames.specimen:
          this.addEquip.appLevel = 'Specimen Type';
          break;
      }
      this._serviceRequestService.addEquipment(this.addEquip).subscribe(
        (response: string) => {
          this.getJobTypeData();
          switch (type) {
            case ServiceTypeNames.equipment:
              this.successMsg('Equipment Type Added Successfully', 'Success');
              break;
            case ServiceTypeNames.organ:
              this.successMsg('Organ Type Added Successfully', 'Success');
              break;
            case ServiceTypeNames.specimen:
              this.successMsg('Specimen Type Added Successfully', 'Success');
              break;
          }
          this.loader = false;
          this.addEquip = {
            serviceType: '',
            equipmentType: '',
            appLevel: '',
          };
        },
        (error) => {
          this.loader = false;
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      );
    }
  } // reference in template file

  addAdditionalEquipmentType() {
    if (this.addEquip.equipmentType != '') {
      this.loader = true;
      this.addEquip.serviceType = 'Transmedics';
      this.addEquip.appLevel = 'Transmedics';
      this._serviceRequestService.addAdditionalEquipmentType(this.addEquip).subscribe(
        (response: string) => {
          this.successMsg('New Additional Equipment Type Added Successfully', 'Success');
          this.getAdditionalEquipmentTypes();
          this.loader = false;
          this.addEquip = {
            serviceType: '',
            equipmentType: '',
            appLevel: '',
          };
        },
        (error) => {
          this.loader = false;
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      );
    }
  } // reference in template file

  clearData(serviceTypeName: string) {
    this.addEquip.equipmentType = '';
    switch (serviceTypeName) {
      case ServiceTypeNames.equipment:
        this.isShowAddEquipment = false;
        break;
      case ServiceTypeNames.organ:
        this.isShowAddOrgan = false;
        break;
      case ServiceTypeNames.specimen:
        this.isShowAddSpecimen = false;
        break;
      default:
        break;
    }
  } // reference in template file

  public selectedJobId: string;
  public isStateSelected: boolean = false;
  deleteJobType(type: string) {
    if (
      (this.equipmentDataModel.selectedEquipment && this.equipmentDataModel.selectedEquipment.jobTypeId) ||
      (this.organDataModel.selectedOrgan && this.organDataModel.selectedOrgan.jobTypeId) ||
      (this.specimenDataModel.selectedSpecimen && this.specimenDataModel.selectedSpecimen.jobTypeId)
    ) {
      let confirmation: boolean;
      switch (type) {
        case ServiceTypeNames.equipment:
          this.selectedJobId = this.equipmentDataModel.selectedEquipment.jobTypeId;
          confirmation = confirm(
            ConfirmationMsg.manageData('delete', type.toLowerCase(), this.equipmentDataModel.selectedEquipment.jobTypeName),
          );
          break;
        case ServiceTypeNames.organ:
          this.selectedJobId = this.organDataModel.selectedOrgan.jobTypeId;
          confirmation = confirm(ConfirmationMsg.manageData('delete', type.toLowerCase(), this.organDataModel.selectedOrgan.jobTypeName));
          break;
        case ServiceTypeNames.specimen:
          this.selectedJobId = this.specimenDataModel.selectedSpecimen.jobTypeId;
          confirmation = confirm(
            ConfirmationMsg.manageData('delete', type.toLowerCase(), this.specimenDataModel.selectedSpecimen.jobTypeName),
          );
          break;
      }
      if (confirmation) {
        this.loader = true;
        this._serviceRequestService.deleteJobType(this.selectedJobId).subscribe(
          (response: boolean) => {
            this.getJobTypeData();
            this.loader = false;
            switch (type) {
              case ServiceTypeNames.equipment:
                this.successMsg('Equipment Type Deleted Successfully', 'Success');
                this.equipmentDataModel.selectedEquipment = null;
                break;
              case ServiceTypeNames.organ:
                this.successMsg('Organ Type Deleted Successfully', 'Success');
                this.organDataModel.selectedOrgan = null;
                break;
              case ServiceTypeNames.specimen:
                this.successMsg('Specimen Type Deleted Successfully', 'Success');
                this.specimenDataModel.selectedSpecimen = null;
                break;
            }
          },
          (error) => {
            this.loader = false;
            console.log(error);
            this.warningMsg('Something went wrong!', 'Warning');
          },
        );
      }
    }
  } // reference in template file

  deleteAdditionalEquipmentType() {
    if (this.additionalEquipmentDataModel.selectedAdditionalEquipmentType.additionalEquipmentId != undefined) {
      let confirmation = confirm(
        ConfirmationMsg.manageData(
          'delete',
          'additional equipment type',
          this.additionalEquipmentDataModel.selectedAdditionalEquipmentType.additionalEquipmentName,
        ),
      );
      if (confirmation) {
        this.loader = true;
        this._serviceRequestService
          .deleteJobType(this.additionalEquipmentDataModel.selectedAdditionalEquipmentType.additionalEquipmentId)
          .subscribe(
            (response: boolean) => {
              this.successMsg('Additional Equipment Type Deleted Successfully', 'Success');
              this.getAdditionalEquipmentTypes();
              this.loader = false;
              this.additionalEquipmentDataModel.selectedAdditionalEquipmentType = null;
            },
            (error) => {
              this.loader = false;
              console.log(error);
              this.warningMsg('Something went wrong!', 'Warning');
            },
          );
      }
    }
  } // reference in template file

  deleteSelectedLocation() {
    if (this.mapOriginDataModel.locationSelected.addressId != undefined) {
      let confirmation: boolean = confirm(
        ConfirmationMsg.manageData('delete', 'location', this.mapOriginDataModel.locationSelected.locationName),
      );
      if (confirmation) {
        let addressId = this.mapOriginDataModel.locationSelected.addressId;
        this._memberService.deleteLocation(addressId).subscribe(
          (response: boolean) => {
            this.successMsg('Location Deleted Successfully.', 'Success');
            this.getAllServiceLocations(true);
            this.mapOriginDataModel.locationSelected = undefined;
          },
          (error) => {
            console.log(error);
            this.warningMsg('Something went wrong!', 'Warning');
          },
        );
      }
    }
  } // reference in template file

  disableSelectedLocation() {
    if (this.mapOriginDataModel.locationSelected.addressId != undefined) {
      let confirmation: boolean = confirm(
        ConfirmationMsg.manageData('disable', 'location', this.mapOriginDataModel.locationSelected.locationName),
      );
      if (confirmation) {
        let addressId = this.mapOriginDataModel.locationSelected.addressId;
        this._memberService.disableLocation(addressId).subscribe(
          (response: boolean) => {
            this.successMsg('Location Disabled Successfully.', 'Success');
            this.getAllServiceLocations(true);
            this.mapOriginDataModel.locationSelected = undefined;
          },
          (error) => {
            console.log(error);
            this.warningMsg('Something went wrong!', 'Warning');
          },
        );
      }
    }
  } // reference in template file

  editSelectedLocationName(editLocationForm: NgForm) {
    if (editLocationForm.valid) {
      if (this.mapOriginDataModel.locationSelected.addressId != undefined) {
        let editLocationData: IEditLocationModel;
        editLocationData = {
          addressId: this.mapOriginDataModel.locationSelected.addressId,
          addressName: this.mapOriginDataModel.locationSelected.locationName,
          locationAddressType: this.mapOriginDataModel.locationSelected.locationAddressType,
          isGlobal: this.mapOriginDataModel.locationSelected.isGlobal,
          airportCode:
            this.mapOriginDataModel.locationSelected.isGlobal == null ? this.mapOriginDataModel.locationSelected.airportCode : null,
          airportName: this.airportCodeList.find((airport) => airport.airportCode === this.mapOriginDataModel.locationSelected.airportCode)
            ?.airportName,
        };
        this._memberService.editLocationName(editLocationData).subscribe(
          (response: boolean) => {
            this.successMsg('Location Edited Successfully.', 'Success');
            this.getAllServiceLocations(true);
            this.mapOriginDataModel.locationSelected = undefined;
          },
          (error) => {
            console.log(error);
            this.warningMsg('Something went wrong while updating location name!', 'Warning');
          },
        );
      } else {
        this.warningMsg('Unable to update location name!', 'Warning');
      }
      $('#addLocation').modal('hide');
    } else {
      $('#addLocation').modal('show');
    }
  } // reference in template file

  public isShowAddCityOption: boolean = false; // reference in template file
  public selectedState: string;
  getStateList() {
    this._subscriptions.add(
      this._vendorService.getStateList().subscribe(
        (response) => {
          this.stateDataModel.stateList = response;
        },
        (error) => {
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      ),
    );
  }

  getCityListBasedOnSelectedState(event) {
    this.isStateSelected = true;
    this.selectedState = event.value.stateId;
    this._subscriptions.add(
      this._vendorService.getCityByState(this.selectedState).subscribe(
        (response: CityViewModel[]) => {
          this.cityDataModel.cityList = response;
        },
        (error) => {
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      ),
    );
  }

  public cityAdd: ICityViewModel = {
    cityId: DefaultGUID,
    id: DefaultGUID,
    cityName: '',
    cityCode: '',
    stateId: DefaultGUID,
  };

  addCity() {
    if (this.cityAdd.cityName != '') {
      this.editCity = true;
      this.cityAdd.stateId = this.selectedState;
      this._memberService.addCity(this.cityAdd).subscribe(
        (response: string) => {
          this.successMsg('City Added Successfully', 'Success');
          let selectedState = { value: { stateId: this.selectedState } };
          this.getCityListBasedOnSelectedState(selectedState);
          this.clearCityData();
          this.editCity = false;
        },
        (err) => {
          this.editCity = false;
          console.log(err);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      );
    } else {
      this.clearCityData();
    }
  } // reference in template file

  public editCity: boolean = false;

  deleteCity() {
    let confirmation: boolean = confirm(ConfirmationMsg.manageData('delete', 'city', this.cityDataModel.selectedCity.cityName));
    if (confirmation) {
      this.editCity = true;
      this._memberService.deleteCity(this.cityDataModel.selectedCity['cityId']).subscribe(
        (response: boolean) => {
          let selectedState = { value: { stateId: this.selectedState } };
          this.successMsg('City Deleted Successfully', 'Success');
          this.getCityListBasedOnSelectedState(selectedState);
          this.cityDataModel.selectedCity = null;
          this.editCity = false;
        },
        (error) => {
          console.log(error);
          this.warningMsg('Something went wrong!', 'Warning');
        },
      );
    }
  } // reference in template file

  clearCityData() {
    this.cityAdd = {
      cityId: DefaultGUID,
      id: DefaultGUID,
      cityName: '',
      cityCode: '',
      stateId: DefaultGUID,
    };
  }

  changeLocation(event) {
    if (event.value.dispalyName != null) {
      this.locationDisplayName = event.value.dispalyName;
    } else {
      this.locationDisplayName = event.value.locationName;
    }
  } // reference in template file

  addDisplayName() {
    let displayNameObj = {
      addressId: this.mapOriginDataModel.locationSelected.addressId,
      displayName: this.locationDisplayName,
    };
    this.loader = true;
    this._memberService.addDisplayName(displayNameObj).subscribe(
      (response: string) => {
        let index = this.mapOriginDataModel.serviceLocations.findIndex((x) => x.addressId == displayNameObj.addressId);
        if (index != -1) {
          this.mapOriginDataModel.serviceLocations[index].dispalyName = response;
        }
        this.loader = false;
        this.successMsg('Display Name added successfully.', 'Success');
      },
      (error) => {
        this.loader = false;
        this.locationDisplayName = null;
        this.warningMsg('Something went wrong! Please try again', 'Warning');
      },
    );
  } // reference in template file

  private successMsg(message: string, title: string): void {
    this._toast.success(message, title, { timeOut: 6000, positionClass: 'toast-top-center' });
  }

  private warningMsg(message: string, title: string): void {
    this._toast.warning(message, title, { timeOut: 6000, positionClass: 'toast-top-center' });
  }

  IsObjectNull(obj: IGetLocationViewModel) {
    return obj == null || Object.keys(obj).length === 0;
  } // reference in template file

  public getAllAirportCodeList() {
    if (this._locationService.airportCodeList$.value.length > 0) {
      this.airportCodeList = this._locationService.airportCodeList$.value;
    } else {
      this._subscriptions.add(
        this._locationService.getAllAirportCodeList().subscribe((response: IAirportCodeList[]) => {
          this.airportCodeList = response;
        }),
      );
    }
  }

  public checkForAirportLocation(locationSelected: IGetLocationViewModel) {
    if (locationSelected.airportCode) {
      locationSelected.isGlobal = null;
    }
  } // reference in template file

  public addAirportCode() {
    this.airportCodeList.push({
      addressId: this.mapOriginDataModel.locationSelected.addressId,
      airportCode: this.airport.toUpperCase(),
      airportName: null,
    });
    this.mapOriginDataModel.locationSelected.airportCode = this.airport.toUpperCase();
    this.airport = '';
  } // reference in template file
}
